import { Add } from "@mui/icons-material";
import { Button, Typography } from "@mui/material";
import React from "react";
import { defaultClassification } from "./ConfigDefault";
import { useFormConfigContext } from "./ConfigFormContext";

const ConfigNoClassification: React.FC = () => {
  const { setValue } = useFormConfigContext();

  return (
    <>
      <Typography className="italic">
        L’étape de classification vous aide à déterminer le type de vos
        documents. Elle peut avoir lieu avec ou sans découpage. Si cette étape
        est définie, elle s’effectuera sur chacun des documents présent dans le
        dossier. Si un découpage est également défini au préalable, elle
        s’effectuera alors aussi sur l’ensemble des sous-documents qui ont été
        découpés.
      </Typography>
      <div className="flex justify-center">
        <Button
          variant="contained"
          onClick={() =>
            setValue("config.classification", defaultClassification())
          }
          className="gap-2"
        >
          <Add />
          Classification
        </Button>
      </div>
    </>
  );
};
export default ConfigNoClassification;
